import { ArrowRight, Sparkles, Wand2 } from "lucide-react";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/b1ee0792-8313-479c-984a-b18d82c4310c/images/15868f79d17e434f5979ba799d3e2c1edf01f6e606e47f5a2e6f151e60fe1f60.png";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-night/70 via-night/60 to-night" />
      <div className="absolute inset-0 star-field opacity-40" />

      {/* Decorative floating sparkles */}
      <Sparkles className="absolute top-32 left-10 w-6 h-6 text-gold/60 float twinkle hidden sm:block" />
      <Sparkles className="absolute top-48 right-16 w-4 h-4 text-mystic twinkle-delay-1 hidden sm:block" />
      <Sparkles className="absolute bottom-40 left-[15%] w-5 h-5 text-gold/40 twinkle-delay-2 hidden sm:block" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-32 pb-16">
        <div className="max-w-3xl">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass mb-8 fade-up"
            data-testid="hero-badge"
          >
            <Wand2 className="w-4 h-4 text-gold" />
            <span className="text-xs uppercase tracking-widest text-[#B5A9C9]">
              Goochelaar & artiest · Dilsen-Stokkem
            </span>
          </div>

          <h1
            className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold leading-[1.02] tracking-tight fade-up"
            style={{ animationDelay: "0.1s" }}
            data-testid="hero-title"
          >
            De magie die
            <br />
            jouw feest
            <br />
            <span className="gold-text italic">onvergetelijk</span> maakt.
          </h1>

          <p
            className="mt-8 text-lg sm:text-xl text-[#B5A9C9] max-w-xl leading-relaxed fade-up"
            style={{ animationDelay: "0.25s" }}
            data-testid="hero-subtitle"
          >
            Goochelshows, tafelgoochelen en circusanimatie voor verjaardagen,
            bedrijfsevents en feesten. Boek Seppe en verras je publiek met magie
            die écht in hun handen gebeurt.
          </p>

          <div
            className="mt-10 flex flex-col sm:flex-row gap-4 fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            <a
              href="#boeken"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gold text-night-deep font-semibold hover:bg-gold-light hover:-translate-y-1 transition-all duration-300 gold-glow-hover"
              data-testid="hero-cta-book"
            >
              Boek Magic Seppe
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#shows"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-gold/60 text-gold hover:bg-gold/10 hover:-translate-y-1 transition-all duration-300"
              data-testid="hero-cta-shows"
            >
              Bekijk de shows
            </a>
          </div>

          <div
            className="mt-16 grid grid-cols-3 gap-6 max-w-lg fade-up"
            style={{ animationDelay: "0.55s" }}
          >
            <div data-testid="hero-stat-shows">
              <div className="font-display text-3xl sm:text-4xl gold-text font-bold">100+</div>
              <div className="text-xs uppercase tracking-wider text-[#7A6C96] mt-1">Shows</div>
            </div>
            <div data-testid="hero-stat-years">
              <div className="font-display text-3xl sm:text-4xl gold-text font-bold">2020</div>
              <div className="text-xs uppercase tracking-wider text-[#7A6C96] mt-1">Goochelt sinds</div>
            </div>
            <div data-testid="hero-stat-smiles">
              <div className="font-display text-3xl sm:text-4xl gold-text font-bold">∞</div>
              <div className="text-xs uppercase tracking-wider text-[#7A6C96] mt-1">Glimlachen</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-night to-transparent pointer-events-none" />
    </section>
  );
}
